// ============================================
// ドロワーメニュー
// ============================================

export default function initDrawer() {
  const hamburger = document.querySelector(".js-hamburger");
  const drawer = document.querySelector(".js-drawer");
  const header = document.querySelector(".l-header");

  if (!hamburger) return;
  let isOpen = false;

  const toggleMenu = () => {
    isOpen = !isOpen;

    hamburger.classList.toggle("is-open");
    drawer.classList.toggle("is-open");
    header.classList.toggle("is-drawer-open");
    document.querySelector("body").classList.toggle("no-scroll");

    hamburger.setAttribute("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");
    hamburger.setAttribute("aria-expanded", isOpen.toString());
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape" && isOpen) {
      toggleMenu();
    }
  };

  if (hamburger) {
    hamburger.addEventListener("click", toggleMenu);
  }
  document.addEventListener("keydown", handleKeydown);
}
